import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  breadcrumb: string;
}

const PageHeader = ({ title, subtitle, breadcrumb }: PageHeaderProps) => (
  <section className="relative bg-charcoal-gradient pt-28 pb-16 md:pt-32 md:pb-20 overflow-hidden noise-overlay">
    {/* Decorative elements */}
    <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-[120px]" />
    <div className="absolute bottom-0 left-0 w-64 h-64 bg-orange-glow/5 rounded-full blur-[100px]" />
    
    <div className="container mx-auto px-4 relative z-10">
      <div className="flex items-center gap-2 text-silver/80 text-[10px] sm:text-xs font-heading uppercase tracking-[0.2em] mb-5">
        <Link to="/" className="hover:text-primary transition-colors duration-300">Home</Link>
        <ChevronRight className="h-3 w-3 text-primary/50" />
        <span className="text-primary">{breadcrumb}</span>
      </div>
      <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl uppercase text-secondary-foreground leading-[1.05]">
        {title}
      </h1>
      {subtitle && (
        <p className="text-silver/70 mt-4 max-w-xl text-sm md:text-base leading-relaxed">{subtitle}</p>
      )}
      <div className="premium-divider mt-8 max-w-[120px]" />
    </div>
  </section>
);

export default PageHeader;
